import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPic from '@/components/UI/EFPic';
import EFArrowBottom from '@/components/UI/svg/CSR/Icons/EFArrowBottom';
import EFArrowTop from '@/components/UI/svg/CSR/Icons/EFArrowTop';

export default function E(): JSX.Element {
    const { useLang, useEffect, Link } = useGlobal();
    const { t } = useLang('csr');

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        const countDuration = 200;

        // 图片
        const imgTl_1 = new TimelineMax();
        imgTl_1.add(
            TweenMax.to('.csr_pc_E .csr-e-img', 1, {
                transform: `scale(1.17) rotate(0) translate(-220px, 50px)`,
            }),
            1,
        );

        const imgScene_1 = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_E',
            triggerHook: 1,
            offset: -100,
            duration: 800,
        }).setTween(imgTl_1);

        const imgTl_2 = new TimelineMax();
        imgTl_1.add(
            TweenMax.to('.csr_pc_E .csr-e-img', 1, {
                transform: `scale(1) rotate(0) translate(0, 0)`,
            }),
        );

        const imgScene_2 = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_E',
            triggerHook: 1,
            offset: 0,
            duration: 100,
        }).setTween(imgTl_2);

        // 一段动画
        const leftTL = new TimelineMax();

        const outBox = TweenMax.to('.srcEInfomation', 1, {
            transform: 'translateX(0)',
        });
        const title = TweenMax.to('.srcEInfomation .e-title', 1, {
            opacity: 1,
        });
        const subTitle = TweenMax.to('.srcEInfomation .e-subTitle', 1, {
            opacity: 1,
            transform: 'translateY(0)',
        });
        const desc = TweenMax.to('.srcEInfomation .e-desc', 1, {
            opacity: 1,
            transform: 'translateY(0)',
        });
        const button = TweenMax.to('.srcEInfomation .e-button-box', 1, {
            opacity: 1,
            transform: 'translateY(0)',
        });

        leftTL.add(outBox, 0).add(title, 0.1).add(subTitle, 0.3).add(desc, 0.5).add(button, 0.7);

        const scene = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_E',
            triggerHook: 1,
            offset: 500,
            duration: countDuration,
        }).setTween(leftTL);

        new ScrollMagic.Controller().addScene(scene).addScene(imgScene_1).addScene(imgScene_2);
    }, []);

    return (
        <div className={`csr_pc_E ${css.csr_pc_E} container`}>
            <div className="srcEInfomation">
                <div className="e-title">{t('secE_title')}</div>
                <div className="e-subTitle">{t('secE_subTitle')}</div>
                <div className="e-desc">{t('secE_text')}</div>
                <div className="e-button-box">
                    <Link href={`/download?url=${encodeURIComponent('https://websiteoss.ecoflow.com/pdf/handbook_compressed.pdf')}`} target="_blank">
                        <div className="e-button">
                            <div className="e-download-text">{t('secE_download')}</div>
                            <div className="e-icon-outbox">
                                <div className="e-icon-box">
                                    <div className="EFArrowTop">
                                        <EFArrowTop />
                                    </div>
                                    <div className="EFArrowBottom">
                                        <EFArrowBottom />
                                    </div>
                                    <div className="arrow-temp">
                                        <EFArrowTop />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="e-imgbox">
                <EFPic className="csr-e-img" src={['/img/csr/pc/e-1.webp', '/img/csr/pc/e-1.png']} />
            </div>
        </div>
    );
}
